import {useId} from 'react'
import {clsx} from 'clsx'

import {Text} from '@primer/react-brand/esm'

import {NavLink, type NavLinkType} from '../NavLink/NavLink'

import styles from './NavGroup.module.css'
import redesignStyles from '../../MarketingNavigationRedesign.module.css'

export type NavGroupType = {
  context?: string
  hasSeparator?: boolean
  items: NavLinkType[]
  render?: boolean
  hideTitle?: boolean
  title: string
}

export function NavGroup(props: NavGroupType & {redesign?: boolean}) {
  const {title, items, render = true, hasSeparator = false, hideTitle = false, context, redesign = false} = props
  const titleId = useId()

  if (render === false) {
    return null
  }

  return (
    <div
      className={clsx(redesign ? redesignStyles.Group : styles.group, hasSeparator && !redesign && styles.hasSeparator)}
    >
      <Text
        as="span"
        id={titleId}
        className={clsx(styles.title, hideTitle && 'visually-hidden')}
        font="monospace"
        variant="muted"
        size="100"
        weight="medium"
      >
        {title}
      </Text>

      <ul
        className={clsx(
          styles.list,
          redesign && redesignStyles.LinkList,
          redesign && items.some(item => item.icon) && redesignStyles.IconList,
        )}
        aria-labelledby={titleId}
      >
        {items.map(item => (
          <li key={item.title}>
            <NavLink {...item} context={context} redesign={redesign} />
          </li>
        ))}
      </ul>
    </div>
  )
}
